const generateSrcSet = sizes => {
  const realSizes = [
    'medium',
    'medium_large',
    'large',
    'full',
  ];

  return realSizes.map(size => (sizes[size] ? `${sizes[size].source_url} ${sizes[size].width}w,` : '')).join('');
};

const compileArticleTemplate = (article, category, isSummary = false) => {
  const thumbnail = isSummary || !article.thumbnail ? ''
    : `<figure class="article__image">
        <a href="${article.link}">
          <img src="${article.thumbnail.guid.rendered}" srcset="${generateSrcSet(article.thumbnail.media_details.sizes)}" alt="${article.thumbnail.title.rendered}">
        </a>
      </figure>`;

  const excerpt = isSummary ? ''
    : `<div class="article__text">
    ${article.excerpt.rendered}
  </div>`;

  const jsDate = new Date(article.date);
  const day = jsDate.getDate().toString().length === 1 ? `0${jsDate.getDate()}` : jsDate.getDate();
  const month = (jsDate.getMonth() + 1).toString().length === 1 ? `0${jsDate.getMonth() + 1}` : jsDate.getMonth() + 1;
  const date = `${day}.${month}.${jsDate.getFullYear()}`;

  return `
    <article class="article ${isSummary ? 'm-bottom--medium' : ''}">
    ${thumbnail}
    <div class="article__meta">
      <svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 512 512" class="article__icon icon">
        <path d="M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32"/><path d="M256 56v120a32 32 0 0032 32h120" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/>
      </svg>
      <div class="article__kicker">
        <a href="${category.link}">${category.name.toUpperCase()}</a>
      </div>
      <time class="article__date">${date}</time>
    </div>
    <h1 class="article__title ${isSummary ? '' : 'article__title--large'}">
      <a href="${article.link}">${article.title.rendered}</a>
    </h1>
    ${excerpt}
    </article>
  `;
};

export default compileArticleTemplate;
